export const translations = {
    CANCEL_PASS_MODAL_NOTIFY: {
        description: 'Be sure to inform your visitor',
        primaryValue: 'Be sure to inform your visitor',
        stringKey: 'CANCEL_PASS_MODAL_NOTIFY',
    },
    CANCEL_PASS_MODAL_KEEP_PASS: {
        description: 'Keep Pass',
        primaryValue: 'Keep Pass',
        stringKey: 'CANCEL_PASS_MODAL_KEEP_PASS',
    },
    CANCEL_PASS_MODAL_CANCEL_PASS: {
        description: 'Cancel Pass',
        primaryValue: 'Cancel Pass',
        stringKey: 'CANCEL_PASS_MODAL_CANCEL_PASS',
    },
    CANCEL_PASS_MODAL_TITLE: {
        description: 'Cancel this pass',
        primaryValue: 'Cancel this pass',
        stringKey: 'CANCEL_PASS_MODAL_TITLE',
    },
    TOASTR_PASS_CANCELED: {
        description: 'Pass Canceled',
        primaryValue: 'Pass Canceled',
        stringKey: 'TOASTR_PASS_CANCELED',
    },
};